import { useGameContext } from "../../../context/gameContext/gameContext";
import { forwardRef } from "react";
import { Image } from "@chakra-ui/react";

const PlayingCard = forwardRef(
  (
    {
      card,
      faceUp,
      url,
      suit,
      owner,
      id,
      shouldDarken,
      className,
      isTrumpRound,
      isBiddingRound,
      trickOver,
      playCard,
    },
    ref
  ) => {
    const imgUrl = faceUp ? url : "/cards/BLUE_BACK.svg";

    const { currentTurn } = useGameContext();

    const conditionalTurn =
      currentTurn === "" ? "" : !className && currentTurn !== owner;

    // Cards stay unclickable out of turn regardless of seat, but only dim
    // for that reason on other seats - graying out the human's own hand
    // while waiting on bots to act looks like something broke, since
    // they'll be able to play again as soon as it's their turn.
    const dimForTurn = conditionalTurn && owner !== "P1";

    return (
      <div
        ref={ref}
        className={className}
        style={{
          transition: "all 0.7s ease",
          pointerEvents:
            conditionalTurn ||
            isTrumpRound ||
            isBiddingRound ||
            trickOver ||
            shouldDarken
              ? "none"
              : "auto",
        }}
      >
        <Image
          className={owner === "P1" ? "main-player" : "playing-card"}
          id={id}
          style={{ opacity: shouldDarken || dimForTurn ? 0.4 : 1 }}
          src={imgUrl}
          alt={card}
          data-suit={suit}
          data-card={card}
          data-owner={owner}
          onClick={className ? null : (e) => playCard(e)}
        />
      </div>
    );
  }
);
export default PlayingCard;
